import { render, staticRenderFns } from "./clock-partition.vue?vue&type=template&id=27915e00&scoped=true"
import script from "./clock-partition.vue?vue&type=script&lang=ts"
export * from "./clock-partition.vue?vue&type=script&lang=ts"
import style0 from "./clock-partition.vue?vue&type=style&index=0&id=27915e00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27915e00",
  null
  
)

export default component.exports